/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Selectors for Wizard Report component
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.4.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../../reducers/rootReducer';
import { IWizardState } from '../../wizardReducer';
import { getWizardState } from '../../wizardSelectors';
import { EWizardReportParam } from './WizardReportConstants';
import { IWizardReportOrderParams, IWizardReportParam } from './wizardReportTypes';

export const makeSelectWizardReportParam = (paramType: EWizardReportParam):
    OutputSelector<IRootReducer, IWizardReportParam, (state: IWizardState) => IWizardReportParam> =>
    createSelector(
        getWizardState,
        state => state[paramType],
    );

export const makeSelectWizardReportOrderParams = ():
    OutputSelector<IRootReducer, IWizardReportOrderParams, (state: IWizardState) => IWizardReportOrderParams> =>
    createSelector(
        getWizardState,
        state => {
            const email = state[EWizardReportParam.EMAIL];
            const phone = state[EWizardReportParam.PHONE];
            const subsNotificationNeeded = state[EWizardReportParam.SUBS_NOTIFICATION_NEEDED];
            const params: IWizardReportOrderParams = { notify: {} };
            if (email.isEnabled) params.notify.email = email.value;
            if (phone.isEnabled) params.notify.phone = phone.value;
            if (subsNotificationNeeded.isEnabled) 
                params.notify.subsNotificationNeeded = true;
            return params;
        },
    );
